import {
  Button,
  Col,
  Form,
  Input,
  message,
  Modal,
  Row,
  Select,
  Spin,
  Upload,
  UploadFile,
  UploadProps,
} from 'antd';
import { DashBoardApiService } from 'features/Dashboard/api/dashboard-api.service';
// import { useUploadImage } from 'features/Dashboard/use-cases/upload-image';
import { DocumentsApiService } from 'features/document-report/api/documents-api.service';
import { useUserContext } from 'features/users';
import { Fragment, useState } from 'react';
import { validateFileBeforeUpload } from 'routes/utils';

export const DocumentsInfoFormItems = ({
  data,
  fileList,
  previewImage,
  previewOpen,
  setFileList,
  setPreviewOpen,
  setPreviewImage,
  setIsImageUploading,
  setFileNames,
  isImageUploading,
}: any) => {
  const { user } = useUserContext();
  const [subCategoryOptions, setSubCategoryOptions] = useState([]);
  const [classOptions, setClassOptions] = useState([]);
  const [blobUrls, setBlobUrls] = useState<string[]>([]);

  // const { mutate: uploadImage } = useUploadImage();
  const handleImageUpload = async (file: UploadFile) => {
    const formData = new FormData();
    formData.append('file', file as any);
    setIsImageUploading(true);

    try {
      // API call to upload the image with separate arguments
      const response = await DashBoardApiService().uploadImageDocument(
        user?.CompanyId as string, // Pass the id as the first argument
        formData, // Pass the formData as the second argument
      );
      // Assuming the response contains a fileName
      setFileNames((prev: any) => [...prev, response.fileName]);
      setBlobUrls((prev) => [...prev, response.blobUrl]); // Store the blob URL for each file
      message.success('File uploaded successfully');
    } catch (error) {
      message.error('Image upload failed');
    } finally {
      setIsImageUploading(false);
    }
  };

  const beforeUpload = (file: any) => {
    const isValid = validateFileBeforeUpload(file);
    if (isValid) {
      handleImageUpload(file);
    }

    return false;
  };

  const handlePreview = async (file: UploadFile, index: number) => {
    // Use the blob URL for previewing the specific file
    setPreviewImage(blobUrls[index] || (file.preview as string));
    setPreviewOpen(true);
  };

  const handleChange: UploadProps['onChange'] = ({ fileList: newFileList }) =>
    setFileList(newFileList);

  const fetchSubCategories = async (categoryId: string) => {
    try {
      const response: any = await DocumentsApiService().dropDownByClassFlag({
        Flag: 'SubCategory',
        ParentId: categoryId,
        CompanyId: user?.CompanyId,
        ClientId: user?.Id,
      });
      setSubCategoryOptions(response?.data?.rc || []);
      setClassOptions([]); // Reset class options when category changes
    } catch (error: any) {
      message.error('Error fetching subcategories');
    }
  };

  const fetchClasses = async (subCategoryId: string) => {
    try {
      const response: any = await DocumentsApiService().dropDownByClassFlag({
        Flag: 'Class',
        ParentId: subCategoryId,
        CompanyId: user?.CompanyId,
        ClientId: user?.Id,
      });
      setClassOptions(response?.data?.rc || []);
    } catch (error: any) {
      message.error('Error fetching classes');
    }
  };

  return (
    <Fragment>
      <Form.Item
        name='DocumentName'
        label='Document Name'
        rules={[
          {
            required: true,
            whitespace: false,
          },
        ]}
      >
        <Input placeholder='Enter Document Name' />
      </Form.Item>
      <Form.Item
        label='Category'
        name='category'
        rules={[
          {
            required: true,
            message: 'Select category',
          },
        ]}
      >
        <Select
          options={data?.data?.rc?.map((item: any) => ({
            label: item.text,
            value: item.value,
          }))}
          onChange={(value) => fetchSubCategories(value)}
          placeholder='Please Select'
        />
      </Form.Item>
      {subCategoryOptions.length > 0 && (
        <Form.Item name='SubCategory' label='Sub Category'>
          <Select
            options={subCategoryOptions.map((item: any) => ({
              label: item.text,
              value: item.value,
            }))}
            onChange={(value) => fetchClasses(value)}
            placeholder='Please Select'
          />
        </Form.Item>
      )}
      {classOptions.length > 0 && (
        <Form.Item name='class' label='Class'>
          <Select
            options={classOptions.map((item: any) => ({
              label: item.text,
              value: item.value,
            }))}
            placeholder='Please Select'
          />
        </Form.Item>
      )}
      <Form.Item label='Upload Documents' name='files'>
        <div className='upld_item mltybs'>
          <Upload
            listType='picture-card'
            fileList={fileList}
            onPreview={(file) => handlePreview(file, fileList.indexOf(file))}
            onChange={handleChange}
            multiple
            maxCount={50}
            accept='.png,.jpeg,.jpg,.webp,.csv,.xlsx,.xls,.pdf'
            beforeUpload={beforeUpload}
          >
            {fileList?.length >= 50 ? null : (
              <div className='upld_img'>
                <img src='/upload-img.png' alt='Upload icon' />
                <p className='drp_text'>
                  Drag and drop here <span>or</span>{' '}
                  <a href='javascript:void(0)'>Browse Files</a>
                </p>
              </div>
            )}
          </Upload>
          {fileList.length > 0 && (
            <div style={{ width: '100%', marginTop: '10px' }}>
              {fileList.map((file: UploadFile, index: any) => (
                <Row
                  key={file.uid}
                  align='middle'
                  justify='space-between'
                  style={{
                    marginBottom: '10px',
                    padding: '8px',
                    background: '#f5f5f5',
                    borderRadius: '8px',
                  }}
                >
                  <Col span={16}>
                    <div>{file.name}</div>
                  </Col>
                  <Col span={8} style={{ textAlign: 'right' }}>
                    <Button
                      type='primary'
                      onClick={() => handlePreview(file, index)}
                      style={{
                        backgroundColor: '#4CAF50',
                        color: 'white',
                        marginLeft: '8px',
                        borderRadius: '8px',
                      }}
                    >
                      Preview
                    </Button>
                  </Col>
                </Row>
              ))}
            </div>
          )}
          {isImageUploading && (
            <div
              style={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                zIndex: 1,
              }}
            >
              <Spin size='large' />
            </div>
          )}
        </div>
        {/* {previewImage && (
          <Image
            wrapperStyle={{ display: 'none' }}
            preview={{
              visible: previewOpen,
              onVisibleChange: (visible) => setPreviewOpen(visible),
              afterOpenChange: (visible) => !visible && setPreviewImage(''),
            }}
            src={previewImage}
          />
        )} */}
        {/* Modal for image preview */}
        <Modal
          open={previewOpen}
          onCancel={() => setPreviewOpen(false)}
          footer={null}
          centered
          width={800}
        >
          {previewImage?.endsWith('.jpg') ||
          previewImage?.endsWith('.jpeg') ||
          previewImage?.endsWith('.png') ||
          previewImage?.endsWith('.webp') ? (
            <img src={previewImage} alt='Preview' />
          ) : (
            <iframe
              src={`https://docs.google.com/gview?url=${previewImage}&embedded=true`}
              style={{ width: '100%', height: '600px', border: 'none' }}
              title='Document Preview'
            />
          )}
        </Modal>
      </Form.Item>
    </Fragment>
  );
};
